import React, { useState, useEffect, Fragment, useMemo } from 'react';
import { Upload, message, Tabs, Modal, List } from 'antd';
import { connect } from 'dva';
import { randomNameUpload, emptyFun } from '@untils/common';
import { uploadButton, getUploadProps, schema, mapName, columns } from './config';
import { createQiniuTokenApi, materialLibraryListApi } from '@service';
import PurposeTable from '../purpose-table';
import SearchForm from '../search-form';
import './index.less';

const { TabPane } = Tabs;

const mapStateToProps = state => ({
  user: state.userInfo.user,
});

const Uploader = props => {
  const {
    max = 9,
    antdProps = {},
    prefix: propsPrefix,
    getUploadFiles = emptyFun,
    value: propsValue,
    isVideo = false,
    isShowUrl,
    user,
  } = props;

  const acceptSuffix = isVideo ? ['video/mp4'] : ['image/png', 'image/jpeg'];
  const [fileList, setFileList] = useState([]);
  const [token, setToken] = useState('');
  const domain = isVideo ? 'http://p0j3yv39n.bkt.clouddn.com' : 'http://ovqxodlhu.bkt.clouddn.com';
  const [isLoadPropsValue, setIsLoadPropsValue] = useState(false);
  const [prefix, setPrefix] = useState('');
  const [visible, setVisible] = useState(false);
  const [record, setRecord] = useState({});
  const [addLength, setAddLength] = useState(1);

  // 多次实例多次请求，需要优化
  const getQiniuToken = async () => {
    if (propsPrefix === 'goods') {
      const goodsUploadToken = localStorage.getItem('goodsUploadToken') || '';

      setPrefix('');
      setToken(goodsUploadToken);
    } else {
      const res = await createQiniuTokenApi({
        method: 'post',
        token: propsPrefix,
      });
      const { token, prefix } = res.data;

      setPrefix(prefix);
      setToken(token);
    }
  };

  useEffect(() => {
    getQiniuToken();
  }, []);

  useEffect(() => {
    if (!isLoadPropsValue) {
      let isLoad = false;
      const files = [];

      propsValue &&
        propsValue.map((item, index) => {
          isLoad = true;
          if (!item) {
            return;
          }
          let key = item;

          if (item.indexOf('http') > -1) {
            key = new URL(item).pathname;
          }
          files.push({
            uid: `-${index + 1}`,
            name: key,
            status: 'done',
            url: item.indexOf('http') > -1 ? item : domain + '/' + item,
            response: {
              key,
            },
          });
        });

      files.length && setFileList([...files]);
      isLoad && setIsLoadPropsValue(true);
    }
  }, [propsValue]);

  const getNecessaryParam = filename => {
    const uploadKey = randomNameUpload(filename);
    const key = prefix === '' ? uploadKey : prefix + '/' + uploadKey;

    return {
      key,
      token,
      'x:prefix': prefix,
      'x:creater_id': user.id,
    };
  };

  const uploadProps = {
    ...getUploadProps(isVideo),
    ...antdProps,
    fileList,
    onChange: ({ file, fileList: fileArr }) => {
      const count = addLength + fileList.length;

      if (fileArr.length === count || file.status === 'removed') {
        const files = fileArr.map(item => {
          const { response = {} } = item;

          return {
            ...item,
            url: response.domain + '/' + response.key,
          };
        });

        setAddLength(1);
        getUploadFiles(files);
        return setFileList(files);
      }
    },
    onPreview: item => {
      const { url, response = {} } = item;

      window.open(url || domain + '/' + response.key);
    },
    beforeUpload: (file, files) => {
      setAddLength(files.length);
      return new window.Promise((resolve, reject) => {
        let msg = '';

        // 判断是否超出长度
        if (files.length + fileList.length > max) {
          msg = `上传数量大于${max}; `;
        }

        // 循环判断错误
        files.map(item => {
          const { name, size, type } = item;

          acceptSuffix.indexOf(type) < 0 && (msg += `${name} 类型错误; `);
          size > (isVideo ? 20971520 : 5242880) && (msg += `${name} 大于${isVideo ? '20M' : '5M'}; `);
        });

        // 当执行所有文件的before之后， 统一给弹窗
        if (file.uid === files[files.length - 1].uid) {
          msg && message.error(msg);
        }

        // 只要有错误， 就reject
        if (!msg) {
          return resolve(true);
        }
        return reject(false);
      });
    },
    data: file => getNecessaryParam(file.name),
  };

  const showModal = () => {
    setVisible(true);
  };

  const handleOk = () => {
    setVisible(false);
  };

  const selectFile = record => {
    setRecord(record);
  };

  useEffect(() => {
    const { id, url, key, file_name } = record;

    if (fileList.length === max) {
      message.error(`超出最大选择${max}!`);
      return;
    }

    if (id) {
      const newFileList = fileList.concat([
        {
          uid: `-${id}`,
          name: file_name,
          status: 'done',
          url,
          response: {
            key: key,
          },
        },
      ]);

      if (newFileList.length === max) {
        setVisible(false);
      }

      if (fileList.some(item => item.uid === `-${id}`)) {
        message.error('已经选择了！请重新选择');
      } else {
        setFileList(newFileList);
        getUploadFiles(newFileList);
      }
    }
  }, [record]);

  const listData = useMemo(() => {
    if (isShowUrl) {
      const data = [];

      fileList.map(item => data.push(item.url));
      return data;
    }
    return [];
  }, [isShowUrl, fileList]);

  return (
    <Fragment>
      <div className="upload-clearfix">
        <Upload {...uploadProps}></Upload>

        {fileList.length < max && (
          <div className="upload-btn" onClick={showModal}>
            {uploadButton}
          </div>
        )}

        {isShowUrl && listData.length > 0 && (
          <div className="inline-middle-box">
            <span className="conspicuous-bold">图片url地址：</span>
            <List size="small" dataSource={listData} renderItem={item => <List.Item>{item}</List.Item>} />
          </div>
        )}
      </div>

      <Modal
        visible={visible}
        onOk={handleOk}
        closable={false}
        className="upload-modal"
        forceRender={true}
        width={1000}
      >
        <Tabs defaultActiveKey="1">
          <TabPane tab="上传" key="1">
            <Upload {...uploadProps}>{fileList.length >= max ? null : uploadButton}</Upload>
          </TabPane>
          <TabPane tab="选择" key="2">
            <SearchForm schema={schema} mapName={mapName} />
            <PurposeTable
              request={materialLibraryListApi}
              selectType="none"
              // getSelectRow={getSelectRow}
              columns={columns}
              rowKey="id"
              param={{
                file_type: isVideo ? 'video' : 'image',
                prefix,
              }}
              needExport={false}
              needSetting={false}
              functionMap={{
                selectFile,
              }}
            />
          </TabPane>
        </Tabs>
      </Modal>
    </Fragment>
  );
};

export default connect(mapStateToProps)(Uploader);
